import { render, staticRenderFns } from "./weixiu.vue?vue&type=template&id=309325e2&scoped=true"
import script from "./weixiu.vue?vue&type=script&lang=js"
export * from "./weixiu.vue?vue&type=script&lang=js"
import style0 from "./weixiu.vue?vue&type=style&index=0&id=309325e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309325e2",
  null
  
)

export default component.exports